
export class DeviceSettingsUpdateRequestCache
{
    private requests: string[] = [];

    public Remove(tid: string): void
    {
        this.requests = this.requests.filter(x => x != tid);
    }

    public Add(tid: string): void
    {
        this.requests.push(tid);
    }

    public IsPending(tid: string): boolean
    {
        return this.requests.includes(tid);
    }
}
